import React, { useState, useEffect } from 'react'

function isElectron() {
  // Renderer process
  if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
    return true;
  }

  // Main process
  if (typeof process !== 'undefined' && typeof process?.versions === 'object' && !!process?.versions.electron) {
    return true;
  }

  // Detect the user agent when the `nodeIntegration` option is set to true
  if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
    return true;
  }

  return false;
}

const PlatformContext = React.createContext()
PlatformContext.displayName = 'PlatformContext'

function PlatformProvider(props) {
  const [platform, setPlatform] = useState(undefined);
  const [isMac, setIsMac] = useState(false);
  const [isWindows, setIsWindows] = useState(false);

  useEffect(() => {
    switch (platform) {
      case "darwin":
        setIsMac(true);
        setIsWindows(false);
        break;
      case "win32":
        setIsMac(false);
        setIsWindows(true);
        break;

      default:
        setIsMac(false);
        setIsWindows(false);
        break;
    }

  }, [platform])



  React.useEffect(() => {
    if (isElectron()) {
      window.api?.receive("platformFromMain", (data) => {
        if (data) {
          setPlatform(data);
        }
      });
      // Send a message to the main process
      window.api?.send("asyncToMain", "platform");
    }
  }, [])

  const value = React.useMemo(() => ({ platform, isMac, isWindows }), [
    platform, isMac, isWindows
  ])
  return <PlatformContext.Provider value={value} {...props} />
}

function usePlatform() {
  const context = React.useContext(PlatformContext)
  if (context === undefined) {
    throw new Error('usePlatform must be used within a PlatformProvider');
  }
  return context
}

export { PlatformProvider, usePlatform }